import { CommissionType } from "./batch/enums";
import {
  Commission,
  DuplicatedCommission,
  ImportedCommission,
  ManuallyAddedCommission,
  SplitAddedCommission,
} from "./batch/types";

export const isDuplicatedCommission = (commission: Commission): commission is DuplicatedCommission =>
  commission.type === CommissionType.DUPLICATED_COMMISSION;

export const isSplitAddedCommission = (commission: Commission): commission is SplitAddedCommission =>
  commission.type === CommissionType.SPLIT_ADDED_COMMISSION;

export const isImportedCommission = (commission: Commission): commission is ImportedCommission =>
  commission.type === CommissionType.IMPORTED_COMMISSION;

export const isManuallyAddedCommission = (commission: Commission): commission is ManuallyAddedCommission =>
  commission.type === CommissionType.MANUALLY_ADDED_COMMISSION;
